import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { TermsConditions } from '@core/models/terms-conditions.model';

@Injectable()
export class TermsConditionsEntityService extends EntityCollectionServiceBase<TermsConditions> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('TermsAndConditions', serviceElementsFactory);
  }
}
